module.exports = __webpack_public_path__ + "44875f31e5e20d8ff2ff7d925b7b056a.png";